"use strict";

exports.__esModule = true;
exports.default = void 0;
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  Name: {
    displayName: 'Name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Description: {
    displayName: 'Description',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Rank: {
    displayName: 'Rank',
    type: 'Number',
    sortable: true,
    filterable: true
  },
  CreatorType: {
    displayName: 'Creator type',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  GroupPermissions: {
    displayName: 'Permissions',
    type: 'Join',
    entities: {
      local: 'Group',
      join: 'GroupPermissions',
      foreign: 'Permission',
      filterString: value => `CreatorType = "User" and ((Name != null and Name.Contains("${value}")) or (Value != null and Value.Contains("${value}")))`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Value',
      limit: 10000
    },
    add: _actions.default.addPermission,
    drop: _actions.default.dropPermission,
    sortable: false,
    filterable: false
  },
  OwnerId: {
    displayName: 'Owner ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  }
};
module.exports = exports.default;